  <ng-template #badgeTpl>
    <nz-badge [nzCount]="count()" [ngClass]="btnClass!" [nzStyle]="{ 'box-shadow': 'none' }">
      <i nz-icon nzType="bell" [ngClass]="btnIconClass!"></i>
    </nz-badge>
  </ng-template>
  @if (data!.length <= 0) {
    <ng-template [ngTemplateOutlet]="badgeTpl" />
  } @else {
    <div
      nz-dropdown
      [nzVisible]="popoverVisible"
      (nzVisibleChange)="onVisibleChange($event)"
      nzTrigger="click"
      nzPlacement="bottomRight"
      [nzOverlayClassName]="overlayCls"
      [nzDropdownMenu]="noticeMenu"
    >
      <ng-template [ngTemplateOutlet]="badgeTpl" />
    </div>
    <nz-dropdown-menu #noticeMenu="nzDropdownMenu">

      <nz-spin [nzSpinning]="loading" [nzDelay]="0">
        <nz-tabset #notificationTabset (nzSelectedIndexChange)="delay()" [nzCentered]="centered">
          <nz-tab [nzTitle]="customTitle" *ngFor="let i of data">
            <ng-template #customTitle>
              <span>{{ i.title }}</span>
              @if (i?.list?.length !== 0) {
                <span class="badge">{{ i.list.length }}</span>
              }
            </ng-template>
          </nz-tab>
        </nz-tabset>
        <ng-container *ngFor="let tab of data; let i = index">
          <div class="notification-tab" [class.visible]="notificationTabset.nzSelectedIndex === i">
            <app-notification-tab [locale]="locale" [data]="tab" (selected)="onSelect($event)"
                                  (cleared)="onClear($event)"></app-notification-tab>
          </div>
        </ng-container>


      </nz-spin>

    </nz-dropdown-menu>
  }

